export const isWindowDefined = () => typeof window !== 'undefined';
//# sourceMappingURL=isWindowDefined.js.map